module.exports = __webpack_public_path__ + "img/05.c214f98f.jpg";